import type { PriceDaily, RMR } from "epsm-api-types/models";
import { TIME_RANGE_MAP } from "../../../config";
import type { SectorsChartType, SectorsTimeRange } from "../../../types";

// Union type to handle both PriceDaily and RMR data
export type TickerDataItem = PriceDaily & Partial<RMR>;

/**
 * Adapter function to normalize ticker data by ensuring there's always a consistent
 * price field to use, regardless of whether the data has 'close', 'adj_close', or 'index_ratio'
 */
export function adaptTickerData(
	tickerData: TickerDataItem[],
	chartType: SectorsChartType,
	timeRange: SectorsTimeRange,
) {
	const field = TIME_RANGE_MAP[timeRange].closePrice;

	return tickerData.map((item) => {
		if (chartType === "Ratio") {
			return {
				...item,
				[field]: item.index_ratio,
			};
		}

		return item;
	});
}
